import React from 'react';

export default class SearchPanel extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};

		this.toggle = this.toggle.bind(this);
		this.handleBtn = this.handleBtn.bind(this);
        this.handleEsc = this.handleEsc.bind(this);
    }

	componentDidMount() {
		const btn = document.querySelector('#menu-search-btn');
		if (btn) {
			btn.addEventListener('click', this.handleBtn);
		}

		document.addEventListener('keydown', this.handleEsc);
	}

	componentWillUnmount() {
		const btn = document.querySelector('#menu-search-btn');
		if (btn) {
			btn.removeEventListener('click', this.handleBtn);
		}

		document.removeEventListener('keydown', this.handleEsc);
	}

    handleEsc(e) {
		if (e.keyCode === 27) {
			e.preventDefault();
			this.toggle();
		}
	}

	handleBtn(e) {
		e.preventDefault();
		this.toggle();
	}

	toggle() {
		if (this.state.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.setState({isOpen: true});
		document.body.style.overflow = 'hidden';
	}

	close() {
		this.setState({isOpen: false});
		document.body.style.overflow = '';
	}

	render() {
		const { isOpen } = this.state;
		
		if (!isOpen) {
			return null;
		}
		
		return (
			<div className={`SearchPanel SearchPanel--open ${this.props.class}`} onClick={(e) => {
				if (e.target === e.currentTarget) this.close();
			}}>
				<div className='SearchPanel_body'>
					{this.props.children}
				</div>
			</div>
		);
	}
}
